<ng-container *transloco="let t">
  @if (page$ | async; as page) {
    <bgo-hero-cover [title]="page.title" [description]="page.description" class="mt-xl h-layout block">
      <cft-back-button [path]="linkService.previousPage || linkService.homePath"></cft-back-button>
      @if (page.bannerImage) {
        <img
          [ngSrc]="page.bannerImage.url"
          [alt]="page.bannerImage.title"
          class="h-full w-full object-cover"
          content="background-image"
          fill
          priority
        />
      }
      <bgo-hero-mobiliar-partnership></bgo-hero-mobiliar-partnership>
      @if (page.mainCallToAction || page.secondaryCallToAction) {
        <bgo-hero-call-to-action-section>
          @if (page.mainCallToAction) {
            <cft-call-to-action
              [callToAction]="page.mainCallToAction"
              callToActionStyle="button"
              buttonStyle="hero"
              [showIcon]="false"
            ></cft-call-to-action>
          }
          @if (page.secondaryCallToAction) {
            <cft-call-to-action
              [callToAction]="page.secondaryCallToAction"
              callToActionStyle="button"
              buttonStyle="secondary"
            ></cft-call-to-action>
          }
        </bgo-hero-call-to-action-section>
      }
    </bgo-hero-cover>
    @if (page.promotionalSection) {
      <bgo-inspiration-section [inspirationSection]="page.promotionalSection" class="h-content-layout pt-2xl pb-3xl">
      </bgo-inspiration-section>
    }
    @if (page.proDirectoryIndustries?.length) {
      <bgo-pro-directory-by-industry-section
        class="py-2xl"
        [title]="page.title"
        [industryIds]="page.proDirectoryIndustries || []"
      ></bgo-pro-directory-by-industry-section>
    }
    <div class="h-content-layout grid grid-cols-1 gap-lg pt-2xl pb-3xl lg:grid-cols-12">
      @if (page.authors.length || page.readingTime) {
        <div class="flex items-center justify-between border-b border-grey-400 pb-md lg:col-span-7">
          @if (page.authors.length) {
            <bgo-authors [authors]="page.authors"></bgo-authors>
          }
          @if (page.readingTime) {
            <cft-chip
              [text]="t('article.readingTimeMinutes', {value: page.readingTime})"
              size="sm"
              colour="grey"
            ></cft-chip>
          }
        </div>
      }
      <cft-content-section
        [plot]="page.contentSectionPlot"
        [title]="page.contentSectionTitle"
        titleAlignment="left"
        class="lg:col-span-7"
      >
        <bgo-rich-text [content]="page.content"></bgo-rich-text>
      </cft-content-section>
      @if (page.contactForm) {
        <aside class="hidden lg:col-span-4 lg:col-start-9 lg:block">
          <cft-contact-form-card
            class="sticky top-32"
            [alternativeCallToAction]="page.contactForm"
            (sendMessage)="clientMessageSent($event)"
            [dataPrivacyLink]="privacyLink"
          ></cft-contact-form-card>
        </aside>
      }
    </div>
    @if (page.presentationSection) {
      <bgo-presentation-section [section]="page.presentationSection"></bgo-presentation-section>
    }
    @if (page.offeringsSection) {
      <bgo-offerings-section
        [offeringsSection]="page.offeringsSection"
        titleAlignment="left"
        class="h-content-layout pt-2xl pb-3xl"
      >
      </bgo-offerings-section>
    }
    @if (page.promotionalBannerSection) {
      <div class="mt-2xl h-content-layout mb-3xl">
        <bgo-promotional-banner-section
          [section]="page.promotionalBannerSection"
          [fullContent]="!!page.content.json?.schema"
        >
        </bgo-promotional-banner-section>
      </div>
    }
    @if (page.inspirationSection) {
      <bgo-inspiration-section [inspirationSection]="page.inspirationSection" class="h-content-layout pt-2xl pb-3xl">
      </bgo-inspiration-section>
    }
    @if (page.knowledgeSection) {
      <bgo-knowledge-section
        [knowledgeSection]="page.knowledgeSection!"
        class="h-content-layout"
      ></bgo-knowledge-section>
    }
    <div class="h-content-layout pt-2xl pb-3xl">
      <cft-content-section [plot]="page.industry.plot" [title]="page.industry.title" titleAlignment="left">
        <cft-slider
          [alignCenter]="false"
          [backButtonTitle]="t('slider.back')"
          [forwardButtonTitle]="t('slider.forward')"
        >
          @for (item of page.industry.items; track item) {
            <cft-icon-card
              [title]="item.title"
              [icon]="item.icon"
              [routerLink]="item.targetPath"
              class="h-48 w-44"
            ></cft-icon-card>
          }
        </cft-slider>
      </cft-content-section>
    </div>
    @if (page.supportSection) {
      <bgo-support-section [supportSection]="page.supportSection"></bgo-support-section>
    }
    <bgo-sticky-bottom-navigation [class.sticky-navigation-show]="showStickyFooter"></bgo-sticky-bottom-navigation>
  }
</ng-container>
